// @ts-ignore - Duplicate identifier from CommonJS pattern
export class ConversationState {
    spec: any;
    nextPc: number;
    message: string;
    options: { [key: string]: string };
    condValue: number;
    condParam: string;
    langId: number;

    constructor(conversationSpec: any, langId: number) {
        this.spec = conversationSpec;
        this.nextPc = 0;
        this.message = "";
        this.options = {};
        this.condValue = -1;
        this.condParam = "";
        this.langId = langId;
    }

    _getStringById(stringId: number) {
        return this.spec.strings[this.langId][stringId];
    }

    exec() {
        this.condParam = "";

        while (true) {
            const currentPc = this.nextPc++;
            const ins = this.spec.instructions[currentPc];

            // Debug and error handling
            if (!ins) {
                console.error(
                    `ERROR: Instruction at PC ${currentPc} is undefined!`
                );
                console.error(
                    `Total instructions: ${this.spec.instructions.length}`
                );
                console.error(`All instructions:`, this.spec.instructions);
                console.error(`Conversation spec:`, this.spec);
                throw new Error(
                    `Invalid instruction at PC ${currentPc}. Total instructions: ${this.spec.instructions.length}`
                );
            }

            console.log(`[ConvState] Executing PC ${currentPc}:`, {
                type: ins.type,
                typeName: ins.typeName,
                entryId: ins.entryId,
                jumpTarget: ins.jumpTarget,
                condValue: ins.condValue,
                currentCondValue: this.condValue
            });

            switch (ins.type) {
                case CXEINSTYPE.NOP:
                    // Do Nothing
                    continue;
                case CXEINSTYPE.CLOSE:
                    // Lock PC to this instruction in case exec is called again
                    this.nextPc = currentPc;
                    return CXECURREQ.CLOSE;
                case CXEINSTYPE.JUMP:
                    this.nextPc = ins.jumpTarget;
                    continue;
                case CXEINSTYPE.JUMPIF:
                    if (this.condValue === ins.condValue) {
                        this.nextPc = ins.jumpTarget;
                    }
                    continue;
                case CXEINSTYPE.SETMESSAGE:
                    this.message = this._getStringById(ins.stringId);
                    this.options = {};
                    continue;
                case CXEINSTYPE.SETOPTION:
                    this.options[ins.optionId] = this._getStringById(
                        ins.stringId
                    );
                    continue;
                case CXEINSTYPE.CLEAROPTIONS:
                    this.options = {};
                    continue;
                case CXEINSTYPE.OPTCONDITION:
                    return CXECURREQ.OPTCONDITION;
                case CXEINSTYPE.LUACONDITION:
                    this.condParam = ins.luaFuncName;
                    return CXECURREQ.LUACONDITION;
                case CXEINSTYPE.QSDCONDITION:
                    this.condParam = ins.qsdTriggerName;
                    return CXECURREQ.QSDCONDITION;
                case CXEINSTYPE.LUAACTION:
                    this.condParam = ins.luaFuncName;
                    return CXECURREQ.LUAACTION;
                case CXEINSTYPE.QSDACTION:
                    this.condParam = ins.qsdTriggerName;
                    return CXECURREQ.QSDACTION;
            }
        }
    }
}

